/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_EMPLOYEE,
  LOAD_EMPLOYEE_SUCCESS,
  LOAD_EMPLOYEE_ERROR,

  UPDATE_AUDIT_STATUS,
  UPDATE_AUDIT_STATUS_SUCCESS,
  UPDATE_AUDIT_STATUS_ERROR,
  UPDATE_AUDIT_RATING,
  UPDATE_AUDIT_RATING_SUCCESS,
  UPDATE_AUDIT_RATING_ERROR,
  UPDATE_AUDIT_REMARKS,
  UPDATE_AUDIT_REMARKS_SUCCESS,
  UPDATE_AUDIT_REMARKS_ERROR,
  LOAD_FREELANCER_QC_DETAILS,
  LOAD_FREELANCER_QC_DETAILS_SUCCESS,
  LOAD_FREELANCER_QC_DETAILS_ERROR,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//Employee list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadEmployee() {
  return {
    type: LOAD_EMPLOYEE,
  }
}

export function loadEmployeeSuccess(employee_list) {
  return {
    type: LOAD_EMPLOYEE_SUCCESS,
    employee_list,
  }
}

/**
 * @param {string} error
 */

export function loadEmployeeError(error) {
  return {
    type: LOAD_EMPLOYEE_ERROR,
    error,
  }
}
//Followup Audit list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadFreelancerList(searchvalue) {
  return {
    type: LOAD_FREELANCER_QC_DETAILS,
    searchvalue,
  }
}

export function loadFreelancerListSuccess(freelancer_qc_details) {
  return {
    type: LOAD_FREELANCER_QC_DETAILS_SUCCESS,
    freelancer_qc_details,
  }
}

/**
 * @param {string} error
 */

export function loadFreelancerListError(error) {
  return {
    type: LOAD_FREELANCER_QC_DETAILS_ERROR,
    error,
  }
}

//Followup Audit Status update
/**
 *
 * @param {integer} id
 * @returns
 */
export function updateAuditStatus(auditStatus) {
  return {
    type: UPDATE_AUDIT_STATUS,
    auditStatus,
  }
}

export function updateAuditStatusSuccess(auditStatus, success) {
  return {
    type: UPDATE_AUDIT_STATUS_SUCCESS,
    auditStatus,
    success,
  }
}

/**
 * @param {string} error
 */

export function updateAuditStatusError(error) {
  return {
    type: UPDATE_AUDIT_STATUS_ERROR,
    error,
  }
}

//Followup Audit Rating update
/**
 *
 * @param {integer} id
 * @returns
 */
export function updateAuditRating(auditRating) {
  return {
    type: UPDATE_AUDIT_RATING,
    auditRating,
  }
}

export function updateAuditRatingSuccess(auditRating, success) {
  return {
    type: UPDATE_AUDIT_RATING_SUCCESS,
    auditRating,
    success,
  }
}

/**
 * @param {string} error
 */

export function updateAuditRatingError(error) {
  return {
    type: UPDATE_AUDIT_RATING_ERROR,
    error,
  }
}
//Followup Audit Remarks update
/**
 *
 * @param {integer} id
 * @returns
 */
export function updateAuditRemarks(auditRemarks) {
  return {
    type: UPDATE_AUDIT_REMARKS,
    auditRemarks,
  }
}

export function updateAuditRemarksSuccess(auditRemarks, success) {
  return {
    type: UPDATE_AUDIT_REMARKS_SUCCESS,
    auditRemarks,
    success,
  }
}

/**
 * @param {string} error
 */

export function updateAuditRemarksError(error) {
  return {
    type: UPDATE_AUDIT_REMARKS_ERROR,
    error,
  }
}

const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadEmployee,
  loadEmployeeSuccess,
  loadEmployeeError,

  loadFreelancerList,
  loadFreelancerListSuccess,
  loadFreelancerListError,
  updateAuditRemarks,
  updateAuditRemarksSuccess,
  updateAuditRemarksError,
  updateAuditRating,
  updateAuditRatingSuccess,
  updateAuditRatingError,
  updateAuditStatus,
  updateAuditStatusSuccess,
  updateAuditStatusError,
}

export default actions
